import { Injectable } from "@angular/core"
import { Apollo } from "apollo-angular"
import { Subscription } from "rxjs"
import gql from 'graphql-tag'
import get from 'lodash-es/get'
import { errorToast } from '../../toaster'
import { Request, RequestActivationMethod, KeywordsPageQuery, Data } from '../queries/keyword.queries'
import { map } from 'rxjs/operators'

const createOrUpdateRequest = gql`
  mutation CreateOrUpdateRequestMutation($input: CreateOrUpdateCustomerRequestMutationInput!) {
    CreateOrUpdateCustomerRequestMutation(input: $input) {
      errors
      request {
        id
        state
        sourceContent {
          id
          type
          content
        }
        customer {
          id
          activeRequestsCount
        }
      }
    }
  }
`

const deleteRequest = gql`
  mutation ($input: DeleteRequestInput!) {
    DeleteRequest(input: $input) {
      errors
      request {
        id
        state
        customer {
          id
          activeRequestsCount
        }
      }
    }
  }
`

@Injectable()
export class RequestMutations {

  mutateSub: Subscription;

  constructor(private apollo: Apollo) {}

  createOrUpdateRequest({customerId, request, activationMethod}: { customerId: number, request: Request, activationMethod?: RequestActivationMethod }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.mutateSub = this.apollo.mutate({
        mutation: createOrUpdateRequest,
        variables: {
          input: {
            customerId,
            request,
            activationMethod
          }
        },
      }).subscribe(({ data }: {data: any}) => {
        if (get(data, 'CreateOrUpdateCustomerRequestMutation.errors', []).length > 0) {
          data.CreateOrUpdateCustomerRequestMutation.errors.forEach(e => errorToast(e))
        } else if (get(data, 'CreateOrUpdateCustomerRequestMutation.request', null)) {
          if (data) {
            resolve(data.CreateOrUpdateCustomerRequestMutation)
          }
        }
      }, (error) => {
        errorToast(error)
      })
    })
  }

  deleteRequest({ customerId, id }: { customerId: number, id: number }): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.mutateSub) this.mutateSub.unsubscribe()
      this.mutateSub = this.apollo.mutate({
        mutation: deleteRequest,
        variables: {
          input: { customerId, id }
        },
        update: (store, mutationResult: any) => {
          const mutationResultData = mutationResult.data.DeleteRequest
          if (mutationResultData.errors.length === 0 && mutationResultData.request) {
            const queryVariables = {
              customerId,
              states: ['draft'],
              search: null
            }
            const dataCache: Data = store.readQuery({query: KeywordsPageQuery, variables: queryVariables})
            const newActiveRequestsCount = dataCache.customer.activeRequestsCount - 1
            const newRequests = dataCache.customer.requests.entries.filter(r => r.id !== id)

            const newDataCache = {
              ...dataCache,
              customer: {
                ...dataCache.customer,
                activeRequestsCount: newActiveRequestsCount,
                requests: newRequests,
              }
            }

            store.writeQuery({
              query: KeywordsPageQuery,
              variables: queryVariables,
              data: newDataCache
            })
          }
        }
      }).pipe(map((result: any) => result.data.DeleteRequest)).subscribe(({errors, request}) => {
        if (errors.length > 0) {
          errors.forEach(e => errorToast(e))
          reject()
        } else if (request) {
          resolve(request)
        }
      })
    })
  }
}
